import { TAlertData } from 'src/context/AlertContext';
import { capturePostHogException } from 'src/utils/posthog';

export class OnyxError extends Error {
    error: TAlertData;

    constructor(error: TAlertData, ...params: ConstructorParameters<typeof Error>) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);
        this.name = 'OnyxError';

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OnyxError);
        }

        // Custom debugging information
        this.error = error;
        if (!error.skipErrorTracking) {
            const message = this.message
                ? this.message
                : `${error.header}: ${error.title ?? error.message}`;

            const trackableError = new OnyxError({ ...error, skipErrorTracking: true }, message);

            // Capture error in PostHog
            capturePostHogException(trackableError, {
                ...error.trackingProperties,
                error_header: error.header,
                error_title: error.title,
                error_type: error.message || error.title
            });
        }
    }
}
